import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#CF0",
  "fill-rule": "evenodd",
  d: "M10.861 1.139a3.89 3.89 0 0 0-5.498 0l-.857.857a.857.857 0 1 0 1.212 1.212l.858-.857a2.173 2.173 0 1 1 3.073 3.073l-.857.858a.857.857 0 0 0 1.212 1.212l.857-.857a3.89 3.89 0 0 0 0-5.498m-2.97 2.97a.857.857 0 0 1 0 1.211l-2.57 2.572A.857.857 0 0 1 4.107 6.68L6.68 4.108a.857.857 0 0 1 1.212 0m-4.683.397a.857.857 0 0 1 0 1.212l-.857.858a2.173 2.173 0 0 0 3.073 3.073l.858-.857a.857.857 0 1 1 1.212 1.212l-.857.857a3.888 3.888 0 0 1-5.498-5.498l.857-.857a.857.857 0 0 1 1.212 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }